import { FC, SVGAttributes } from 'react';

type CartSvgProps = SVGAttributes<SVGElement>;

export const CartSvg: FC<CartSvgProps> = ({ ...props }) => {
    return (
        <svg
            width="81"
            height="76"
            viewBox="0 0 81 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_dd_12371_1306)">
                <path
                    d="M52.1841 24C52.1841 17.3726 46.8115 12 40.1841 12C33.5567 12 28.1841 17.3726 28.1841 24"
                    stroke="#E0E0E0"
                    strokeWidth="4.5"
                    strokeLinecap="round"
                />
                <path
                    d="M62.5595 43.4948C61.9067 51.3289 61.5803 55.2459 58.9969 57.6229C58.9969 57.6229 58.9969 57.6229 58.9969 57.6229C56.4135 60 52.4829 60 44.6217 60L35.7465 60C27.8853 60 23.9547 60 21.3713 57.6229C21.3713 57.6229 21.3713 57.6229 21.3713 57.6229C18.7879 55.2459 18.4615 51.3289 17.8086 43.4948C17.0485 34.373 16.6684 29.812 19.3423 26.906C19.3423 26.906 19.3423 26.906 19.3423 26.906C22.0163 24 26.593 24 35.7465 24L44.6217 24C53.7752 24 58.3519 24 61.0258 26.906C61.0258 26.906 61.0258 26.906 61.0258 26.906C63.6997 29.812 63.3197 34.373 62.5595 43.4948Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="4.5"
                />
                <path
                    d="M28.1841 30V33"
                    stroke="#E0E0E0"
                    strokeWidth="4.5"
                    strokeLinecap="round"
                />
                <path
                    d="M52.1841 30V33"
                    stroke="#E0E0E0"
                    strokeWidth="4.5"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <filter
                    id="filter0_dd_12371_1306"
                    x="-10.8159"
                    y="-3"
                    width="102"
                    height="102"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="3"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect1_dropShadow_12371_1306"
                    />
                    <feOffset dy="6" />
                    <feGaussianBlur stdDeviation="6" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_12371_1306"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feMorphology
                        radius="3"
                        operator="erode"
                        in="SourceAlpha"
                        result="effect2_dropShadow_12371_1306"
                    />
                    <feOffset dy="12" />
                    <feGaussianBlur stdDeviation="9" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="effect1_dropShadow_12371_1306"
                        result="effect2_dropShadow_12371_1306"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect2_dropShadow_12371_1306"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
};
